export const AML_DOCUMENT_STATUSES = {
  REQUESTED: 'REQUESTED',
  OVERDUE: 'OVERDUE',
  SUBMITTED: 'SUBMITTED',
};

export const AML_CASE_STATUSES = {
  REVIEW: 'REVIEW',
  DOCUMENTS_REQUIRED: 'DOCUMENTS_REQUIRED',
  COMPLETED: 'COMPLETED',
  REJECTED: 'REJECTED',
};

export const AML_DOCUMENT_TYPES = {
  BANK_STATEMENT: 'BANK_STATEMENT',
  EMPLOYMENT_CONTRACT: 'EMPLOYMENT_CONTRACT',
  PAYSLIP: 'PAYSLIP',
  SALE_AGREEMENT: 'SALE_AGREEMENT',
  LOAN_AGREEMENT: 'LOAN_AGREEMENT',
  OTHER: 'OTHER',
};